const e = { aria_label: "Suchen", clear: "Entfernen", placeholder_article: "", placeholder_header: "Suchen Sie nach Artikeln" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search32.js.map
